import { webApi } from '@mi-front/api-clients';

export function useFragmentQuery(fragmentId: string) {
  return webApi.useGetFragmentDetailById(fragmentId, {
    query: {
      refetchInterval: (query) => {
        const data = query.state.data;
        if (!data) {
          return false;
        }

        const isMediaWaiting = data.mediaCompletedAt === null;
        const isTranscriptionWaiting = data.transcriptionCompletedAt === null;

        return isMediaWaiting || isTranscriptionWaiting ? 2000 : false;
      },
    },
  });
}

useFragmentQuery.queryKey = (fragmentId: string) =>
  webApi.getFragmentDetailByIdQueryKey(fragmentId);
